<ui-confirmation-dialog
    #remainingColumnConfirmation
    size="small"
    header="import.remainingColumnConfirmation.header"
    primaryButtonLabel="import.remainingColumnConfirmation.primaryButtonLabel"
    secondaryButtonLabel="cancel"
>
    <p>
        {{
            'import.remainingColumnConfirmation.description' | translate: { remainingColumnCount: remainingColumnCount }
        }}
    </p>
    <p>{{ 'import.remainingColumnConfirmation.confirmationQuestion' | translate }}</p>
</ui-confirmation-dialog>

<ui-dialog
    #customFieldModal
    formDialog
    size="small"
    header="import.customFieldModal.header"
    [form]="customFieldForm.form"
    (primaryButtonPressed)="onSaveCustomField(customFieldForm)"
    (closing)="customFieldModal.open = false"
>
    <app-form-data-field-compact #customFieldForm [isLoading]="showModalLoader"></app-form-data-field-compact>
</ui-dialog>

<form class="form" (ngSubmit)="onSubmit()" #form="ngForm">
    <!-- used to invalidate progress to next step until all required fields are set -->
    <input name="requiredFieldsMapped" required type="hidden" [ngModel]="allRequiredFieldsAssigned" />

    <!-- app-employee-column-mapping -->
    <div class="app-grid">
        <div class="columns-9">
            <div class="mapping-sections-container">
                <div
                    class="mapping-section margin-bottom-3"
                    *ngFor="let mappingTable of this.mappingTables | keyvalue: originalKeyValueOrder"
                >
                    <div class="mapping-section-header margin-bottom-2">
                        <h4 class="margin-bottom-1">{{ mappingTable.value.header | translate }}</h4>
                        <div class="section-description">
                            <p>{{ mappingTable.value.description | translate }}</p>
                            <ui-button
                                *ngIf="mappingTable.value.isCustomFieldLocation"
                                (click)="openCustomFieldModal(mappingTable.key)"
                                type="link"
                            >
                                <mat-icon svgIcon="plus"></mat-icon>
                                {{ 'import.mapColumnsStep.createCustomField' | translate }}
                            </ui-button>
                        </div>
                    </div>
                    <div class="mapping-table-header padding-x-5 padding-y-2">
                        <div class="app-grid">
                            <div class="columns-5 flex align-items-center">
                                {{ 'import.mapColumnsStep.humiFields' | translate }}
                                <ui-info
                                    class="margin-left-1"
                                    tooltipPosition="below"
                                    text="import.mapColumnsStep.humiFieldsNote"
                                ></ui-info>
                            </div>
                            <div class="columns-4">
                                {{ 'import.mapColumnsStep.importedColumns' | translate }}
                                <ui-info
                                    class="margin-left-1"
                                    tooltipPosition="below"
                                    text="import.mapColumnsStep.importedColumnsNote"
                                ></ui-info>
                            </div>
                            <div class="columns-3">
                                {{ 'import.mapColumnsStep.dataPreview' | translate }}
                                <ui-info
                                    class="margin-left-1"
                                    tooltipPosition="below"
                                    text="import.mapColumnsStep.dataPreviewNote"
                                ></ui-info>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="mappingTable.value.sections; else emptyTable">
                        <div
                            class="mapping-table padding-x-5 padding-y-2"
                            *ngFor="
                                let section of mappingTable.value.sections | keyvalue: originalKeyValueOrder;
                                let last = last
                            "
                        >
                            <app-mapping-table-section
                                #tableSections
                                [section]="section.value"
                                (triggerValidation)="checkAllRequiredHumiColumnsAreAssigned()"
                            ></app-mapping-table-section>
                            <hr *ngIf="!last" />
                        </div>
                    </div>
                    <ng-template #emptyTable>
                        <div class="empty-mapping-table padding-x-3 padding-y-3">
                            {{ 'import.mapColumnsStep.noCustomFields' | translate }}
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="columns-3 flex">
            <app-unmatched-items
                class="margin-top-4"
                itemType="Columns"
                helperText="{{ 'import.mapColumnsStep.unmatchedHelperText' | translate }}"
                [unmatchedList]="humiColumnService.getUnmatchedColumnItems(importerService.columns)"
            ></app-unmatched-items>
        </div>
    </div>
</form>
